"use client";

import Link from "next/link";
import { AlertTriangle } from "lucide-react";
import { usePathname } from "next/navigation";
import { useBillingTokenStatus } from "@/hooks";

interface BillingTokenStatusBannerProps {
  className?: string;
}

const BillingTokenStatusBanner: React.FC<BillingTokenStatusBannerProps> = ({
  className,
}) => {
  const { needsBankAccount, loadingTokenStatus } = useBillingTokenStatus();
  const pathname = usePathname() ?? "";

  if (loadingTokenStatus) return null;
  if (!needsBankAccount) return null;

  const segments = pathname.split("/").filter(Boolean);
  const locale = segments[0] ?? "pt-BR";
  const relativePath = `/${segments.slice(1).join("/")}`;

  if (
    relativePath === "/subscriptions/bank-account" ||
    relativePath === "/settings/subscriptions"
  ) {
    return null;
  }

  const settingsLink = `/${locale}/subscriptions/bank-account`;
  return (
    <div
      className={`mx-4  rounded-md border border-orange-200 bg-orange-50 px-4 py-3 text-orange-900 shadow-sm ${className ?? ""}`.trim()}
    >
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="flex items-start gap-3">
          <span className="mt-1 rounded-full bg-orange-100 p-1 text-orange-700">
            <AlertTriangle className="h-4 w-4" />
          </span>
          <div className="space-y-1">
            <p className="font-semibold">
              Cadastre a conta bancária para vender assinaturas
            </p>
            <p className="text-sm text-orange-800">
              Conclua o cadastro bancário e habilite as vendas de assinaturas.
            </p>
          </div>
        </div>
        <Link
          href={settingsLink}
          className="inline-flex items-center justify-center rounded-md border border-orange-400 px-4 py-2 text-sm font-medium text-orange-800 transition hover:bg-orange-100"
        >
          Acessar Conta
        </Link>
      </div>
    </div>
  );
};

export default BillingTokenStatusBanner;
